import AnimatedBox from "app/components/common/AnimatedBox";
import React from "react";
import VideoIcon from "./icons/VideoIcon";
import LinkIcon from "./icons/LinkIcon";
import PdfIcon from "./icons/PdfIcon";
import { Box, MainText, PressableOpacity } from "app/components/common";
import { PlayIcon } from "app/components/Icons/Audio/PlayIcon";
import { View } from "react-native";
import theme from "app/Theme/Theme";

const icons = {
  videoLink: {
    icon: <PlayIcon color={theme.colors["brand.500"]} />,
  },
  webLink: {
    icon: <LinkIcon color={theme.colors["brand.500"]} />,
  },
  pdf: {
    icon: <PdfIcon color={theme.colors["brand.500"]} width={14} height={17} />,
  },
};

const ResourceBox = ({
  title = "Gestion des émotions",
  link = "https://blog.microdoing.com",
  type = "link",
  isVisited = false,
  onPress = null,
}) => {
  const goodIcon = icons[type] || {};
  const { backgroundColor = "system.red.950", icon = <LinkIcon /> } = goodIcon;

  // ! mettre le margin dans ce composant n'est pas bien, il devrait être dans le parent => probleme si dans parent la scrollbar est dans la view et pas collé au bord de l'ecran
  return (
    <Box>
      <PressableOpacity onPress={onPress}>
        <AnimatedBox>
          <Box alignItems="center" flexDirection="row">
            <Box
              borderRadius={8}
              backgroundColor="brand.50"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              height={40}
              width={40}
            >
              {icon}
            </Box>
            <Box flex={1} flexDirection="column" marginLeft="sm">
              <MainText
                variant="l4-semibold"
                numberOfLines={1}
                color="neutral.700"
              >
                {title}
              </MainText>
              <View>
                {/* 
                // TODO trouver un meilleur moyen de retirer le marginTop du variant text
                */}
                <MainText
                  variant="l3-medium"
                  numberOfLines={1}
                  color="neutral.400"
                >
                  {link}
                </MainText>
              </View>
            </Box>
            {!isVisited && (
              <Box
                height={10}
                width={10}
                borderRadius={5}
                backgroundColor="system.green.900"
                marginRight="sm"
                marginLeft="sm"
              />
            )}
          </Box>
        </AnimatedBox>
      </PressableOpacity>
    </Box>
  );
};

export default ResourceBox;
